module.exports = __webpack_public_path__ + "static/webapp_preview-0ab147d91720b75357ebecaed91d25be.png";